import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';

import { useAppDispatch, useAppSelector } from '@/features';
import { changeSheet } from '@/features/slice/event/event-slice';
import { useCreateUserMutation } from '@/features/slice/users';
import type { UsersDto } from '@/features/slice/users/types';
import useFetchFieldOptions from '@/hooks/use-fetch-field-options';
import type { FieldOptions } from '@/types/dynamic-control-types';

import { createUserField } from '../user-input';
import { CreateUserSchema } from './create-user.schema';

export const useCreateUser = () => {
    const fieldOptions: FieldOptions = createUserField.reduce((acc, field) => {
        // biome-ignore lint/correctness/useHookAtTopLevel: TODO: It needs to be refactored
        // eslint-disable-next-line react-hooks/rules-of-hooks
        acc[field.fieldName] = useFetchFieldOptions(field.fieldName);
        return acc;
    }, {} as FieldOptions);
    const form = useForm({
        resolver: zodResolver(CreateUserSchema),
        defaultValues: {
            name: '',
            role_id: '',
            email: '',
            password: '',
            phone_number: '',
        },
    });
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = form;
    const dispatch = useAppDispatch();
    const { sheetStatus } = useAppSelector((state) => state.eventSlice);
    const [createUser, { isLoading }] = useCreateUserMutation();
    const onSubmit = async (value: UsersDto) => {
        try {
            const response = await createUser(value);

            if (response) {
                toast.success('Successfully added new user.');
                dispatch(changeSheet(!sheetStatus));
            }
        } catch (error) {
            console.error(error);
        }
    };
    return {
        fieldOptions,
        handleSubmit: handleSubmit(onSubmit),
        control,
        errors,
        form,
        isLoading,
    };
};
